<template>
  <li class="side-nav-item">
    <router-link :to="to">{{text}}</router-link>
    <slot/>
  </li>
</template>

<script>
export default {
  name: 'SideNavItem',

  props: {
    to: {
      type: String,
      required: true,
    },

    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
  ul.side-nav-items {
    li.side-nav-item {
      display: block;

      font-family: 'Sitka Subheading', serif;
      font-size: 1.25rem;

      a {
        display: block;
        padding: 1rem 2rem 0 2rem;

        color: black;
        text-decoration: none;

        &.router-link-exact-active {
          color: rgba(0, 0, 0, 0.5);
        }
      }
    }

    &.side-nav-sub-items {
      li.side-nav-item {
        font-size: 1rem;

        a {
          padding: 0.5rem 2rem 0 3rem;
        }
      }
    }
  }
</style>
